import React, { useState, useEffect } from 'react';
import {
  Form,
  Input,
  Col,
  Row,
  Card,
  Radio,
  DatePicker,
  message,
  Empty,
  Select,
  Space,
  Divider,
  Tag
} from 'antd';
import FormItem from '@/common/FormItem';
import CustomButton from '@/common/CustomButton';
import { useDispatch, useSelector } from 'react-redux';
import CustomTable from 'common/Content/CustomTable';
import { columns } from './constants.js';
import { useParams } from 'react-router-dom';
import styles from '@/common/Layout/index.module.less';
import { history } from 'app/history';
import moment from 'moment';
import dayjs from 'dayjs';
import {
  createChecklist,
  getDispenseMaterialDetails,
  getPreviousProduct,
  getCampaignBatches,
  getAllDispenseBooths,
  getBatchMaterialDetails,
  getSamplingCampaignBatches
} from '../../redux/slice.js';
import { qacreateChecklist } from '@/features/qc/components/lineclearancechecklist/redux/slice.js';
import { printLC } from '@/features/qc/components/lineclearancechecklist/redux/slice.js';
import { QrReader } from 'react-qr-reader';
import { useLocation } from 'react-router-dom';
import { EditOutlined } from '@ant-design/icons';
import { getLoggedInUser } from 'utilities/helpers';
const dateFormat = 'YYYY-MM-DD';
const datetimeFormat = 'YYYY-MM-DD HH:mm';

const CreateLineClearanceChecklistPage = () => {
  const [form] = Form.useForm();
  const [aHU, setAHU] = useState('off');
  const [lAF, setLAF] = useState('off');
  const dispatch = useDispatch();
  const params = useParams();
  const [wHLC, setWHLC] = useState({});
  const [qALC, setQALC] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const { materialDetails } = useSelector((state) => state.materialDetails);
  const [campaigns, setCampaigns] = useState([]);
  const [dispenseBooths, setDispenseBooths] = useState([]);
  const [weighingBal, setWeighingBal] = useState(false);
  const [proposedData, setProposedData] = useState({});
  const [isPrintDisabled, setIsPrintDisabled] = useState(false);

  const searchParam = useLocation().search;
  const searchParams = new URLSearchParams(searchParam);
  const material = materialDetails?.type;

  const { user } = getLoggedInUser();

  const handleError = (err) => {
    console.error(err);
  };

  // Helper function to check if sampling type
  const isSamplingType = () => searchParams?.get('type') === 'sampling';

  // Helper function to check if approved
  // QC initiators should never see the approval view - they need to fill the form
  const isApproved =
    user?.role === 'qc_initiator'
      ? false
      : isSamplingType()
      ? materialDetails?.lc_status === 'LC Approved' ||
        materialDetails?.lc_status === 'QALC Approved'
      : materialDetails?.status === 'Approved';

  // Log state values at render time
  console.log('=== Component Render ===');
  console.log('user role:', user?.role);
  console.log('isApproved:', isApproved);
  console.log('materialDetails?.lc_status:', materialDetails?.lc_status);
  console.log('wHLC state:', wHLC);
  console.log('qALC state:', qALC);
  console.log('wHLC has keys:', Object.keys(wHLC || {}).length > 0);
  console.log('qALC has keys:', Object.keys(qALC || {}).length > 0);

  // Helper function to get response text
  const getResponseText = (value) => {
    if (value == 1) return 'Yes';
    if (value == 2) return 'No';
    if (value == 3) return 'NA';
    return 'Not Filled';
  };

  // Helper function to render approval status
  const renderApprovalStatus = (whValue, qaValue) => (
    <Space size={16}>
      {wHLC &&
        Object.keys(wHLC).length > 0 &&
        `WH: ${getResponseText(whValue)}`}
      {qALC &&
        Object.keys(qALC).length > 0 &&
        `QA: ${getResponseText(qaValue)}`}
    </Space>
  );

  useEffect(() => {
    handleGetDispenseBooths();
    handleGetAllMaterials();
    if (isSamplingType()) {
      handleGetCampaignBatches();
    } else {
      handleGetAllCampaignBatches();
    }
  }, []);

  useEffect(() => {
    if (materialDetails) {
      populateFormFields();
      filterLCData();
    }
  }, [materialDetails, proposedData]);

  const filterLCData = () => {
    if (isSamplingType()) {
      // For sampling type, get data from line_clearance_batches
      const qaLineClearanceBatches =
        materialDetails?.line_clearance_batches?.[0]?.qa_line_clearance_batches;

      const lc_filter = qaLineClearanceBatches?.filter(
        (item) => item?.lc_type == 'lc_initiated'
      );
      const lc_qa_filter = qaLineClearanceBatches?.filter(
        (item) => item?.lc_type == 'lc_submitted'
      );

      setWHLC(lc_filter?.[0] || {});
      setQALC(lc_qa_filter?.[0] || {});
    } else {
      // For non-sampling type, use existing lcChecklistData
      const lc_filter = materialDetails?.lcChecklistData?.filter(
        (item) => item?.lc_type == 'lc_initiated'
      );
      const lc_qa_filter = materialDetails?.lcChecklistData?.filter(
        (item) => item?.lc_type == 'lc_submitted'
      );

      setWHLC(lc_filter?.[0] || {});
      setQALC(lc_qa_filter?.[0] || {});
    }
  };

  const handleGetCampaignBatches = () => {
    const batchIds = localStorage.getItem('batches');
    if (!batchIds) return;

    let payload = {
      batch_details_id:
        user?.role == 'qc_initiator'
          ? JSON.parse(batchIds)
          : String(localStorage.getItem('batches')).split(',')
    };

    dispatch(getSamplingCampaignBatches(payload)).then(function (result) {
      if (result?.payload?.success) {
        setCampaigns(result?.payload?.data);
      }
    });
  };

  const handleGetAllMaterials = () => {
    let payload = {
      id: params.id
    };
    const apiCall =
      searchParams.get('type') == 'sampling'
        ? getBatchMaterialDetails(payload)
        : getDispenseMaterialDetails(payload);

    dispatch(apiCall).then(function (result) {
      if (result?.payload?.success) {
        if (searchParams.get('type') == 'sampling') {
          const lcData = result?.payload?.data?.line_clearance_batches?.[0];
          console.log(lcData);
          setProposedData(result?.payload?.data);
          populateLineClearanceData(lcData, result?.payload?.data);
        } else {
          const lcData = result?.payload?.data?.line_clearance_input;
          const checklistData = result?.payload?.data?.lcChecklistData?.[0];
          populateLineClearanceData(lcData, null, checklistData);
        }

        localStorage.setItem('bmr_number', result?.payload?.data?.bmr_number);
        localStorage.setItem(
          'product_batch_number',
          result?.payload?.data?.product_batch_number
        );
      }
    });
  };

  const populateLineClearanceData = (
    lcData,
    // samplingData = null,
    checklistData = null
  ) => {
    if (!lcData && !checklistData) return;

    const data =
      checklistData || lcData?.qa_line_clearance_batches?.[0] || lcData;

    // Set switch states
    if (lcData?.laf_switched_on == 'on') setLAF('on');
    if (lcData?.area_ahu_switched_on == 'on') setAHU('on');

    // Populate form fields
    form.setFieldsValue({
      dispense_sampling_booth_id: lcData?.dispense_sampling_booth_id,
      previous_product_name: lcData?.previous_product_name || 'NA',
      previous_product_batch_no: lcData?.previous_product_batch_no || 'NA',
      area_ahu_switched_on: lcData?.area_ahu_switched_on || 'NA',
      area_ahu_time_date: lcData?.area_ahu_time_date
        ? moment(lcData?.area_ahu_time_date)
        : null,
      laf_switched_on: lcData?.laf_switched_on || 'NA',
      laf_time_date: lcData?.laf_time_date
        ? moment(lcData?.laf_time_date)
        : null,
      magnehelle_guage_reading_dispensing_samping_area:
        lcData?.magnehelle_guage_reading_dispensing_samping_area,
      temperature: lcData?.temperature,
      relative_humidity: lcData?.relative_humidity,
      pre_filter: lcData?.pre_filter || data?.pre_filter,
      fine_filter: lcData?.fine_filter || data?.fine_filter,
      hepa_filter: lcData?.hepa_filter || data?.hepa_filter,
      date: lcData?.date ? moment(lcData?.date) : moment(),

      // Checklist items
      no_containers_of_previous_material:
        data?.no_containers_of_previous_material,
      checked_unavailablity_used_dispensing_sample_aids_area:
        data?.checked_unavailablity_used_dispensing_sample_aids_area,
      checked_unavailablity_vivible_powder_observed_around_the_area:
        data?.checked_unavailablity_vivible_powder_observed_around_the_area,
      dustbins_are_cleared: data?.dustbins_are_cleared,
      cleaning_of_floor: data?.cleaning_of_floor,
      cleaning_of_covings: data?.cleaning_of_covings,
      cleaning_of_electrical: data?.cleaning_of_electrical,
      previous_record_removed: data?.previous_record_removed,
      cleaniness_working_area: data?.cleaniness_working_area,
      balance_calbration_carried_out: data?.balance_calbration_carried_out,
      check_the_packing_condition: data?.check_the_packing_condition,
      checked_the_material: data?.checked_the_material,
      checked_the_retest_date: data?.checked_the_retest_date,
      swab_results_of_previous_product: data?.swab_results_of_previous_product,
      availability_cleanness_nitrogen: data?.availability_cleanness_nitrogen,
      sodium_vapour_lamps_required_proposed_product:
        data?.sodium_vapour_lamps_required_proposed_product,
      cleaniness_of_pass_box: data?.cleaniness_of_pass_box,
      ensure_the_cleanliness_and_validity:
        data?.ensure_the_cleanliness_and_validity,
      ensure_the_cleanliness_of_the_label:
        data?.ensure_the_cleanliness_of_the_label,
      ensure_that_if_any_gaps_observed: data?.ensure_that_if_any_gaps_observed
    });
  };

  const populateFormFields = () => {
    form.setFieldsValue({
      bmr_number:
        materialDetails?.bmr_number || localStorage.getItem('bmr_number'),
      product_code: materialDetails?.product_detail?.code,
      product_name: materialDetails?.product_detail?.name,
      proposed_product_name:
        (searchParams?.get('type') == 'sampling'
          ? proposedData?.material?.name
          : materialDetails?.product_detail?.name) ||
        localStorage.getItem('proposed_product_name'),
      proposed_product_batch_no:
        (searchParams?.get('type') == 'sampling'
          ? proposedData?.inhouse_batch_number
          : materialDetails?.product_batch_number) ||
        localStorage.getItem('proposed_product_batch_no')
    });
  };

  const handleGetDispenseBooths = () => {
    dispatch(getAllDispenseBooths()).then((result) => {
      if (result?.payload?.success) {
        setDispenseBooths(result?.payload?.data);
      }
    });
  };

  const handleQrScanWeighing = async (scanData) => {
    if (scanData && scanData !== '') {
      form.setFieldsValue({ equipment_name: scanData.text });
      setWeighingBal(false);
    }
  };

  const handleGetAllCampaignBatches = () => {
    const batchIds = localStorage.getItem('batches');
    if (!batchIds) return;

    let payload = {
      dispensing_request_id: String(batchIds).split(',')
    };

    dispatch(getCampaignBatches(payload)).then(function (result) {
      if (result?.payload?.success) {
        setCampaigns(result?.payload?.data);
      }
    });
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
    console.log('Error fields:', errorInfo.errorFields);
    if (errorInfo.errorFields.length > 0) {
      errorInfo.errorFields.forEach((field) => {
        console.log('Missing field:', field.name[0], field.errors);
      });
      message.error(
        'Please select a response to all the questions in the checklist'
      );
    }
  };

  const onFinish = (values) => {
    // Add metadata
    if (isEdit) {
      values['id'] = materialDetails?.line_clearance_input?.id;
      values['line_clear_id'] = materialDetails?.lcChecklistData?.[0]?.id;
    }

    values['dispensing_request_id'] = params.id;
    values['date'] = values?.date
      ? values.date.format('YYYY-MM-DD')
      : moment().format('YYYY-MM-DD');
    values['area_ahu_time_date'] = values?.area_ahu_time_date
      ? values.area_ahu_time_date.format('YYYY-MM-DD HH:mm')
      : moment().format('YYYY-MM-DD HH:mm');
    values['laf_time_date'] = values?.laf_time_date
      ? values.laf_time_date.format('YYYY-MM-DD HH:mm')
      : moment().format('YYYY-MM-DD HH:mm');

    values['proposed_product_name'] = materialDetails?.product_detail?.name;
    values['proposed_product_batch_no'] = materialDetails?.product_batch_number;
    values['compaign_batches'] = localStorage.getItem('batches')
      ? user?.role == 'qc_initiator'
        ? JSON.parse(localStorage.getItem('batches'))
        : String(localStorage.getItem('batches')).split(',')
      : [params.id];
    values['type'] = searchParams.get('type');

    console.log('Form values:', values);

    dispatch(
      user?.role == 'qc_initiator'
        ? qacreateChecklist(values)
        : createChecklist(values)
    ).then(function (response) {
      if (response?.payload?.success) {
        message.success(response.payload.message);
        if (searchParams?.get('type') === 'sampling') {
          history.push('/batches-list?type=lc_sampling');
        } else {
          history.push('/dispense-material-list');
        }
        form.resetFields();
      }
    });
  };

  const disabledDate = (current) => {
    return current && current > dayjs().endOf('day');
  };

  const handleBoothId = (e) => {
    const payload = {
      dispense_sampling_booth_id: e,
      type: searchParams?.get('type')
    };
    dispatch(getPreviousProduct(payload)).then(function (response) {
      if (response?.payload?.success) {
        form.setFieldsValue({
          previous_product_name:
            response?.payload?.data?.product_name ||
            localStorage.getItem('previous_product_name') ||
            'NA',
          previous_product_batch_no:
            response?.payload?.data?.batch_number ||
            localStorage.getItem('previous_product_batch_no') ||
            'NA'
        });
      }
    });
  };

  const printLcPdf = () => {
    setIsPrintDisabled(true);
    const payload = {
      id:
        searchParams?.get('type') == 'sampling'
          ? materialDetails?.line_clearance_batches?.[0]?.id
          : params.id,
      type: searchParams?.get('type')
    };
    dispatch(printLC(payload)).then(function (response) {
      if (response?.payload?.success) {
        window.open(
          `${process.env.REACT_APP_STORAGE_URL}${response?.payload?.url
            .split('/')
            .pop()}`,
          '_blank'
        );
        setIsPrintDisabled(false);
      } else {
        setIsPrintDisabled(false);
      }
    });
  };

  const isDisabled = isSamplingType()
    ? materialDetails?.lc_status === 'LC Approved' ||
      materialDetails?.lc_status === 'QALC Approved' ||
      (materialDetails?.status === 'QA LC Pending' && !isEdit)
    : materialDetails?.status === 'QA LC Pending' && !isEdit;

  let locale = {
    emptyText: (
      <span>
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        <div className={styles.empty_state_text}>
          There are no material requests to display
        </div>
      </span>
    )
  };

  const renderChecklistItem = (label, name, whKey, qaKey) => {
    const whFieldKey = whKey || name;
    const qaFieldKey = qaKey || name;
    console.log('adasd');
    // Calculate isApproved here to use latest state
    // QC initiators should never see approval view
    const checkIsApproved =
      user?.role === 'qc_initiator'
        ? false
        : isSamplingType()
        ? materialDetails?.lc_status === 'LC Approved' ||
          materialDetails?.lc_status === 'QALC Approved'
        : materialDetails?.status === 'Approved';

    // Check if we have data in wHLC or qALC
    const hasWHData = wHLC && Object.keys(wHLC).length > 0;
    const hasQAData = qALC && Object.keys(qALC).length > 0;
    const shouldShowApprovalView = checkIsApproved && (hasWHData || hasQAData);

    console.log('=== renderChecklistItem Debug ===');
    console.log('Label:', label);
    console.log('user role:', user?.role);
    console.log('checkIsApproved:', checkIsApproved);
    console.log('hasWHData:', hasWHData);
    console.log('hasQAData:', hasQAData);
    console.log('shouldShowApprovalView:', shouldShowApprovalView);
    console.log('wHLC:', wHLC);
    console.log('qALC:', qALC);

    return (
      <Row gutter={24}>
        <Col xs={24} xl={24} span={24}>
          <FormItem
            label={label}
            name={name}
            rules={
              !shouldShowApprovalView
                ? [
                    {
                      required: true,
                      message: `Please select ${label.toLowerCase()}`
                    }
                  ]
                : []
            }
          >
            {shouldShowApprovalView ? (
              renderApprovalStatus(wHLC?.[whFieldKey], qALC?.[qaFieldKey])
            ) : (
              <Radio.Group disabled={isDisabled}>
                <Radio value={1}>Yes</Radio>
                <Radio value={2}>No</Radio>
                <Radio value={3}>NA</Radio>
              </Radio.Group>
            )}
          </FormItem>
        </Col>
      </Row>
    );
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Card
        className={styles.cardStyles_approver}
        title={`Line Clearance Checklist - ${
          material == 'bmr' ? 'BMR Based' : 'Material Code Based'
        }`}
        extra={
          materialDetails?.status === 'QA LC Pending' ? (
            <EditOutlined type="primary" onClick={() => setIsEdit(true)} />
          ) : materialDetails?.lc_status === 'QALC Approved' ? (
            <CustomButton
              type="primary"
              ghost
              onClick={printLcPdf}
              disabled={isPrintDisabled}
            >
              Print
            </CustomButton>
          ) : (
            ''
          )
        }
      >
        <Row gutter={24}>
          {material == 'bmr' && searchParams?.get('type') !== 'sampling' && (
            <>
              <Col xs={24} xl={6} span={6}>
                <FormItem label="BMR Number" className={styles.customLable}>
                  <Input
                    placeholder="Enter BMR Number"
                    value={materialDetails?.product_detail?.bmr_bpr_code}
                    disabled
                  />
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem label="Product Name" className={styles.customLable}>
                  <Input
                    disabled
                    value={materialDetails?.product_detail?.name || 'NA'}
                  />
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  label="Product Batch Number"
                  className={styles.customLable}
                >
                  <Input
                    disabled
                    value={materialDetails?.product_batch_number || 'NA'}
                  />
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem label="Effective Date" className={styles.customLable}>
                  <Input
                    disabled
                    value={
                      materialDetails?.effective_date
                        ? moment(materialDetails?.effective_date).format(
                            'DD MMM YYYY'
                          )
                        : 'NA'
                    }
                  />
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem label="Batch Size" className={styles.customLable}>
                  <Input
                    disabled
                    value={
                      materialDetails?.product_detail?.theoretical_batch_size ||
                      'NA'
                    }
                  />
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem label="MFC Number" className={styles.customLable}>
                  <Input disabled value={materialDetails?.ref_mfc || 'NA'} />
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem label="Product Code" className={styles.customLable}>
                  <Input
                    disabled
                    value={materialDetails?.product_code || 'NA'}
                  />
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem label="Label Claim" className={styles.customLable}>
                  <Input
                    disabled
                    value={materialDetails?.label_claim || 'NA'}
                  />
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  label="Manufacturing Date"
                  className={styles.customLable}
                >
                  <Input
                    disabled
                    value={
                      materialDetails?.manufacturing_date
                        ? moment(materialDetails?.manufacturing_date).format(
                            'DD MMM YYYY'
                          )
                        : 'NA'
                    }
                  />
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem label="Expiry Date" className={styles.customLable}>
                  <Input
                    disabled
                    value={materialDetails?.expiry_date || 'NA'}
                  />
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  label="Manufacturing Site"
                  className={styles.customLable}
                >
                  <Input
                    disabled
                    value={materialDetails?.manufacturing_site || 'NA'}
                  />
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  label="Market / Customer Details"
                  className={styles.customLable}
                >
                  <Input
                    disabled
                    value={materialDetails?.customer_details || 'NA'}
                  />
                </FormItem>
              </Col>
              <Col xs={24} xl={8} span={8}>
                <FormItem
                  label="Product Batch #"
                  className={styles.customLable12}
                >
                  {campaigns.map((batch) => (
                    <Tag key={batch?.id} style={{ fontSize: '14px' }}>
                      {batch?.product_batch_number}
                    </Tag>
                  ))}
                </FormItem>
              </Col>
            </>
          )}
        </Row>

        {material == 'material' && (
          <CustomTable
            locale={locale}
            columns={columns}
            dataSource={materialDetails?.dispensing_materials}
            className={styles.scrolling}
            scroll={{ x: 'auto' }}
            pagination={false}
          />
        )}

        <Divider />

        <Row gutter={24}>
          <Col xs={24} xl={12} span={12}>
            <FormItem
              label="Dispensing Sample Booth ID No"
              name="dispense_sampling_booth_id"
              className={styles.customLable}
            >
              {isApproved ? (
                <Input disabled />
              ) : (
                <Select
                  placeholder="Select Sample Booth ID Number"
                  onChange={handleBoothId}
                  disabled={isDisabled}
                >
                  {dispenseBooths?.map((item, index) => (
                    <Select.Option value={item?.booth_id} key={index}>
                      {item?.booth_id}
                    </Select.Option>
                  ))}
                </Select>
              )}
            </FormItem>
          </Col>
          <Col xs={24} xl={12} span={12}>
            <FormItem label="Date" name="date" className={styles.customLable}>
              {isApproved ? (
                <Input disabled />
              ) : (
                <DatePicker
                  style={{ width: '100%' }}
                  format={dateFormat}
                  disabledDate={disabledDate}
                  disabled={isDisabled}
                />
              )}
            </FormItem>
          </Col>
        </Row>

        <Row gutter={24}>
          <Col xs={24} xl={12} span={12}>
            <FormItem
              label="Previous Product Name"
              name="previous_product_name"
              className={styles.customLable}
            >
              <Input disabled />
            </FormItem>
          </Col>
          <Col xs={24} xl={12} span={12}>
            <FormItem
              label="Previous Batch No"
              name="previous_product_batch_no"
              className={styles.customLable}
            >
              <Input disabled />
            </FormItem>
          </Col>
        </Row>

        <Row gutter={24}>
          <Col xs={24} xl={12} span={12}>
            <FormItem
              label="Proposed Product Name"
              name="proposed_product_name"
              className={styles.customLable}
            >
              <Input disabled />
            </FormItem>
          </Col>
          <Col xs={24} xl={12} span={12}>
            <FormItem
              label="Proposed Batch No"
              name="proposed_product_batch_no"
              className={styles.customLable}
            >
              {searchParams?.get('type') == 'sampling'
                ? campaigns?.map((batch) => (
                    <Tag key={batch?.id} style={{ fontSize: '14px' }}>
                      {batch?.inhouse_batch_number}
                    </Tag>
                  ))
                : campaigns?.map((batch) => (
                    <Tag key={batch?.id} style={{ fontSize: '14px' }}>
                      {batch?.product_batch_number}
                    </Tag>
                  ))}
            </FormItem>
          </Col>
        </Row>

        <Row gutter={24}>
          <Col xs={24} xl={12} span={12}>
            <FormItem
              label="Area AHU Switch Status"
              name="area_ahu_switched_on"
              className={styles.customLable}
            >
              {isApproved ? (
                <Input disabled />
              ) : (
                <Select
                  placeholder="Select AHU switch status"
                  onChange={(e) => setAHU(e)}
                  disabled={isDisabled}
                >
                  <Select.Option value="on">ON</Select.Option>
                  <Select.Option value="off">OFF</Select.Option>
                </Select>
              )}
            </FormItem>
          </Col>
          {aHU == 'on' && (
            <Col xs={24} xl={12} span={12}>
              <FormItem
                label="Time & Date"
                name="area_ahu_time_date"
                className={styles.customLable}
              >
                {isApproved ? (
                  <Input disabled />
                ) : (
                  <DatePicker
                    showTime={{ format: 'HH:mm' }}
                    style={{ width: '100%' }}
                    format={datetimeFormat}
                    disabledDate={disabledDate}
                    disabled={isDisabled}
                  />
                )}
              </FormItem>
            </Col>
          )}
          <Col xs={24} xl={12} span={12}>
            <FormItem
              label="LAF Switch Status"
              name="laf_switched_on"
              className={styles.customLable}
            >
              {isApproved ? (
                <Input disabled />
              ) : (
                <Select
                  placeholder="Select LAF switch status"
                  onChange={(e) => setLAF(e)}
                  disabled={isDisabled}
                >
                  <Select.Option value="on">ON</Select.Option>
                  <Select.Option value="off">OFF</Select.Option>
                </Select>
              )}
            </FormItem>
          </Col>
          {lAF == 'on' && (
            <Col xs={24} xl={12} span={12}>
              <FormItem
                label="Time & Date"
                name="laf_time_date"
                className={styles.customLable}
              >
                {isApproved ? (
                  <Input disabled />
                ) : (
                  <DatePicker
                    showTime={{ format: 'HH:mm' }}
                    style={{ width: '100%' }}
                    format={datetimeFormat}
                    disabledDate={disabledDate}
                    disabled={isDisabled}
                  />
                )}
              </FormItem>
            </Col>
          )}
        </Row>

        <Row gutter={24}>
          <Col xs={24} xl={24} span={24}>
            <FormItem
              label="Magnehelic gauge reading Dispensing Sample Area"
              name="magnehelle_guage_reading_dispensing_samping_area"
              className={styles.customLable}
            >
              <Input disabled={user?.role === 'qc_initiator' ? true : false} />
            </FormItem>
          </Col>
        </Row>

        <Row gutter={24}>
          <Col xs={24} xl={12} span={12}>
            <FormItem
              label="Temperature(℃)"
              name="temperature"
              className={styles.customLable}
            >
              <Input disabled={user?.role === 'qc_initiator' ? true : false} />
            </FormItem>
          </Col>
          <Col xs={24} xl={12} span={12}>
            <FormItem
              label="% Relative Humidity"
              name="relative_humidity"
              className={styles.customLable}
            >
              <Input disabled={user?.role === 'qc_initiator' ? true : false} />
            </FormItem>
          </Col>
        </Row>
      </Card>

      <br />

      <Card
        className={styles.cardStyles_approver}
        title="LAF Magnehelle Gauge Reading"
      >
        <Row gutter={24}>
          <Col xs={24} xl={8} span={8}>
            <FormItem
              label="Pre Filter"
              name="pre_filter"
              className={styles.customLable}
            >
              <Input disabled={user?.role === 'qc_initiator' ? true : false} />
            </FormItem>
          </Col>
          <Col xs={24} xl={8} span={8}>
            <FormItem
              label="Fine Filter"
              name="fine_filter"
              className={styles.customLable}
            >
              <Input disabled={user?.role === 'qc_initiator' ? true : false} />
            </FormItem>
          </Col>
          <Col xs={24} xl={8} span={8}>
            <FormItem
              label="HEPA Filter"
              name="hepa_filter"
              className={styles.customLable}
            >
              <Input disabled={user?.role === 'qc_initiator' ? true : false} />
            </FormItem>
          </Col>
        </Row>

        <Divider />

        {renderChecklistItem(
          'No containers of previous material were observed in the area',
          'no_containers_of_previous_material',
          'no_containers_of_previous_material',
          'no_containers_of_previous_material'
        )}

        {renderChecklistItem(
          'Checked for the unavailability of used dispensing/sampling aids in the area',
          'checked_unavailablity_used_dispensing_sample_aids_area',
          'checked_unavailablity_used_dispensing_sample_aids_area',
          'checked_unavailablity_used_dispensing_sample_aids_area'
        )}

        {renderChecklistItem(
          'Checked for the unavailability of visible powder observed around the balance',
          'checked_unavailablity_vivible_powder_observed_around_the_area',
          'checked_unavailablity_vivible_powder_observed_around_the_area',
          'checked_unavailablity_vivible_powder_observed_around_the_area'
        )}

        {renderChecklistItem(
          'Dustbins are cleared, and scraps are removed',
          'dustbins_are_cleared',
          'dustbins_are_cleared',
          'dustbins_are_cleared'
        )}

        {renderChecklistItem(
          'Cleaning of floor, Stainless steel panels of dispensing/sampling booth',
          'cleaning_of_floor',
          'cleaning_of_floor',
          'cleaning_of_floor'
        )}

        {renderChecklistItem(
          'Cleaning of the covings',
          'cleaning_of_covings',
          'cleaning_of_covings',
          'cleaning_of_covings'
        )}

        {renderChecklistItem(
          'Cleaning of the electrical fixtures of dispensing/sampling booth',
          'cleaning_of_electrical',
          'cleaning_of_electrical',
          'cleaning_of_electrical'
        )}

        {renderChecklistItem(
          'Previous records removed from the area',
          'previous_record_removed',
          'previous_record_removed',
          'previous_record_removed'
        )}

        {renderChecklistItem(
          'Cleanliness of the working area',
          'cleaniness_working_area',
          'cleaniness_working_area',
          'cleaniness_working_area'
        )}

        {renderChecklistItem(
          'Balance calibration carried out',
          'balance_calbration_carried_out',
          'balance_calbration_carried_out',
          'balance_calbration_carried_out'
        )}

        {renderChecklistItem(
          'Checked the packing condition of the to be dispensed/sampling materials and found satisfactory',
          'check_the_packing_condition',
          'check_the_packing_condition',
          'check_the_packing_condition'
        )}

        {renderChecklistItem(
          'Checked the material name, material code, approved status etc. by scanning of QR code of to be dispensed material',
          'checked_the_material',
          'checked_the_material',
          'checked_the_material'
        )}

        {renderChecklistItem(
          'Checked the retest date, best before use date and expiry date of to be dispensed/sampling material through QR code scanning and found satisfactory',
          'checked_the_retest_date',
          'checked_the_retest_date',
          'checked_the_retest_date'
        )}

        {renderChecklistItem(
          'Swab results of previous product (If any) are found satisfactory',
          'swab_results_of_previous_product',
          'swab_results_of_previous_product',
          'swab_results_of_previous_product'
        )}

        {renderChecklistItem(
          'Availability & cleanliness of nitrogen purging',
          'availability_cleanness_nitrogen',
          'availability_cleanness_nitrogen',
          'availability_cleanness_nitrogen'
        )}

        {renderChecklistItem(
          'Sodium vapor lamps required for proposed product',
          'sodium_vapour_lamps_required_proposed_product',
          'sodium_vapour_lamps_required_proposed_product',
          'sodium_vapour_lamps_required_proposed_product'
        )}

        {renderChecklistItem(
          'Check the cleanliness of pass box.',
          'cleaniness_of_pass_box',
          'cleaniness_of_pass_box',
          'cleaniness_of_pass_box'
        )}

        {renderChecklistItem(
          'Ensure the cleanliness and cleanliness validity of the dispensing aids as per the status label',
          'ensure_the_cleanliness_and_validity',
          'ensure_the_cleanliness_and_validity',
          'ensure_the_cleanliness_and_validity'
        )}

        {renderChecklistItem(
          'Ensure the cleanliness of the Label counting machine and verify the usage logbook up-dation',
          'ensure_the_cleanliness_of_the_label',
          'ensure_the_cleanliness_of_the_label',
          'ensure_the_cleanliness_of_the_label'
        )}

        {renderChecklistItem(
          'Ensure that if any gaps observed in dispensing /sampling booth shall be closed with suitable',
          'ensure_that_if_any_gaps_observed',
          'ensure_that_if_any_gaps_observed',
          'ensure_that_if_any_gaps_observed'
        )}
      </Card>

      <br />

      {searchParams.get('type') == 'sampling'
        ? (materialDetails?.lc_status == 'WH LC Pending' ||
            materialDetails?.lc_status == 'Under Sampling' ||
            materialDetails?.lc_status == 'QALC Pending' ||
            materialDetails?.lc_status == null) && (
            <div className={styles.submitbutton}>
              <FormItem className="text-center">
                <Space>
                  <CustomButton type="primary" htmlType="submit">
                    Submit
                  </CustomButton>
                  <CustomButton
                    type="primary"
                    ghost
                    onClick={() => history.push('/dashboard')}
                  >
                    Back
                  </CustomButton>
                </Space>
              </FormItem>
            </div>
          )
        : materialDetails?.status !== 'Approved' && (
            <div className={styles.submitbutton}>
              <FormItem className="text-center">
                <Space>
                  <CustomButton type="primary" htmlType="submit">
                    Submit
                  </CustomButton>
                  <CustomButton
                    type="primary"
                    ghost
                    onClick={() => history.push('/dashboard')}
                  >
                    Back
                  </CustomButton>
                </Space>
              </FormItem>
            </div>
          )}

      {isApproved && (
        <FormItem className="text-center">
          <CustomButton
            type="primary"
            ghost
            onClick={() => history.push('/dashboard')}
          >
            Back
          </CustomButton>
        </FormItem>
      )}

      {weighingBal && (
        <QrReader
          constraints={{
            facingMode: 'environment'
          }}
          delay={1000}
          onError={handleError}
          onResult={(result) => handleQrScanWeighing(result)}
          style={{
            width: '3px',
            height: '3px'
          }}
        />
      )}
    </Form>
  );
};

export default CreateLineClearanceChecklistPage;
